import React, { ReactNode } from 'react';
import { OModal, OButton, OResponsiveModal } from '@src/shared';
import cn from 'classnames';
import styles from './WebinarModal.module.scss';
import { useMediaQuery } from '@mui/material';

export type TButtonVariant = 'primary' | 'alternative' | 'success' | 'danger' | 'cancel' | 'disabled' | 'secondary';
export type TButtonSize = 'small' | 'medium' | 'x-medium' | 'large' | 'x-small' | 'm-small' | 'default';

export interface ActionButton {
  text: string;
  variant?: TButtonVariant;
  outlined?: boolean;
  size?: TButtonSize;
  onClick: () => void;
  loading?: boolean;
}

export interface WebinarModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string | ReactNode;
  description?: string | ReactNode;
  children?: ReactNode;
  actions: ActionButton[];
  classes?: {
    container?: string;
    closeIconWrapper?: string;
    closeIcon?: string;
    body?: string;
    title?: string;
  };
}

const WebinarModal: React.FC<WebinarModalProps> = ({
  isOpen,
  onClose,
  title,
  description,
  children,
  actions,
  classes = {},
}) => {
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <OResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      title={typeof title === 'string' && isMobile ? title : undefined}
      modalClasses={{
        ...classes,
        body: cn(styles.container, classes?.body),
        closeIconWrapper: cn('iconModal', classes?.closeIconWrapper),
        closeIcon: cn('iconModal', classes?.closeIcon),
        title: cn(styles.webinarModalTitle, classes?.title),
      }}
    >
      <div className={styles.webinarModalContainer}>
        {!isMobile && <div className={styles.webinarModalTitle}>{title}</div>}
        {description && <p className={styles.webinarModalDescription}>{description}</p>}
        {children}

        <div className={styles.webinarModalActions}>
          {actions.map((btn, idx) => (
            <OButton
              key={idx}
              text={btn.text}
              variant={btn.variant}
              outlined={btn.outlined}
              size={btn.size}
              onClick={btn.onClick}
              loading={btn.loading}
              disabled={btn.loading}
            />
          ))}
        </div>
      </div>
    </OResponsiveModal>
  );
};

export default WebinarModal;
